import { Component} from '@angular/core'; 
import { DebtService } from '../_Services/debt.service';
import { CommonService } from '../_Services/common.service';
 

import { Router, ActivatedRoute } from '@angular/router';  

@Component({
  templateUrl: 'edit.component.html'
})
export class EditComponent {

    model: any = {};
    responseStatus:Object= [];
    status:boolean ;
    error = '';  

    debt = [];  
    assign = [];  
    service = [];
    agency = [];
    collections = [];
    debtimported = []; 
 
    assignment = [];

    balance = 0;

    totalCurr: Number = 0;
    blondal = [];

    lastPayment = [];

    constructor(private router: Router, private debtService: DebtService, private route:ActivatedRoute) { 
         
    }
 

    ngOnInit() { 
        var id = this.route.snapshot.params['id'];
        this.debtService.getDebt(id).subscribe(result => {    
            this.debt = result.info.DebtInformation;
            this.assign = result.assignment.AssignmentDebt;
            this.assignment = result.assignment.Assignment;
            this.agency = result.assignment.Agency;
            this.service = result.service.FinanceService;
            this.debtimported = result.info.DebtImported;

            let total:number = Number(result.info.DebtInformation.curr_os_osp) + Number(result.info.DebtInformation.curr_os_interest) + Number(result.info.DebtInformation.curr_os_charge);
            
            this.blondal = result.blondal;

            this.totalCurr =total;
            this.collections = result.collections; 

            this.lastPayment = result.last;
            console.log(this.lastPayment);
            this.balance = 0;
            for(let data of result.collections) {
                this.balance -= data.CollectionInformation.amount;
            } 
        });  
    }

    onSubmit() {
        console.log(this.model);

        var id = this.route.snapshot.params['id'];
        this.debtService.editCustomer(this.model, id).subscribe(result => {
            console.log(result);
            if (result.status === true) {
                this.router.navigate(['/debts/viewdebt/' + id]);
            } else {
                this.error = 'Please correct error fields'; 
            }
        }); 
    }

}



// WEBPACK FOOTER //
// ./src/app/debts/edit.component.ts